import './component.scss'
import '@splidejs/splide/css';
import Splide from '@splidejs/splide';
import 'PackWerkNurikaeSite/pages/company/show/partials/fv_image_cta/component';

document.addEventListener('DOMContentLoaded', function() {
  const carouselElement = document.getElementById('company-mv-image-carousel');

  if (carouselElement !== null) {
    const splide = new Splide('.splide#company-mv-image-carousel', {
      type: 'loop',
      pagination: false,
      arrows: false,
    }).mount();

    // サムネイルのアクティブ状態を更新
    function updateThumbnails(index) {
      const thumbnails = document.querySelectorAll('.company-sp-mv-image__thumbnail[data-thumbnail-index]');
      thumbnails.forEach((thumb, i) => {
        if (i === index) {
          thumb.classList.add('company-sp-mv-image__thumbnail--active');
        } else {
          thumb.classList.remove('company-sp-mv-image__thumbnail--active');
        }
      });
    }

    // スライド変更時にサムネイルを更新
    splide.on('active', function() {
      updateThumbnails(splide.index);
    });

    // サムネイルクリックでスライドを切り替え
    const thumbnails = document.querySelectorAll('.company-sp-mv-image__thumbnail[data-thumbnail-index]');
    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', function() {
        const index = parseInt(this.dataset.thumbnailIndex, 10);
        splide.go(index);
      });
    });

    // カスタムナビゲーションボタン
    const navLeft = document.querySelector('.company-sp-mv-image__nav-left');
    const navRight = document.querySelector('.company-sp-mv-image__nav-right');

    if (navLeft) {
      navLeft.addEventListener('click', function() {
        splide.go('<');
      });
    }

    if (navRight) {
      navRight.addEventListener('click', function() {
        splide.go('>');
      });
    }
  }
});
